import  { useState, useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { getOsobePosjednikKnjiga } from '../../util/apiOsoba';
import SmallMultiFilter from '../custom/SmallMultiFilter';



const PosjednikKnjigaSelect=({selectedPosjednici=[],onPosjednikSelect})=> {
    const [stPosjednici,setStPosjednici]=useState([]);
    const [err,setErr]=useState("");
    //id,naziv
    useEffect(() => {
        const fetchPosjednikeKnjiga=async()=>{
            try {
              const _res=await getOsobePosjednikKnjiga({orderbycolumn:"naziv",orderby:"asc"});
              if (_res.status===200) {
                setStPosjednici(_res.res);
              } else {
                throw new Error(_res.message);
              }
            } catch (error) {
              setErr(error.message);
            }
          }

          fetchPosjednikeKnjiga();
    }, []);
    const posjednikSelected=(x)=>{
      onPosjednikSelect(x);
    }
    const showPosjednike=()=>{
      if (stPosjednici.length!==0) {
        return (
          
            <SmallMultiFilter data={stPosjednici} selectedid={selectedPosjednici} showheader={true} dataheader='' idfieldname='id' textfieldname='naziv' onSelect={(x)=>{onPosjednikSelect(x)}}/>
          
        )
      }
     }
    return ( 
        <Box>
        {showPosjednike()}        
        </Box>
     );

     
}

export default PosjednikKnjigaSelect;